import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput, Select, Switch } from '@origo/origo-ui';
import type { PlanInfoFormValues, SelectOption } from '../../../types';
import PageSection from '../../../components/PageSection';
import layout from './PlanInfoLayout.module.css';

interface NameStatusSectionProps {
    values: Pick<PlanInfoFormValues, 'plannavn' | 'plantype' | 'planstatus' | 'planbestemmelser'>;
    plantypeOptions: SelectOption[];
    planstatusOptions: SelectOption[];
    errors?: Partial<Record<'plannavn' | 'plantype' | 'planstatus', string>>;
    onChange: <K extends 'plannavn' | 'plantype' | 'planstatus' | 'planbestemmelser'>(
        field: K,
        value: PlanInfoFormValues[K]
    ) => void;
}

const NameStatusSection: React.FC<NameStatusSectionProps> = ({
    values,
    plantypeOptions,
    planstatusOptions,
    errors = {},
    onChange,
}) => {
    const { t } = useTranslation();

    return (
        <PageSection title={t('planInfo.sections.nameStatus')} asFieldset>
            <TextInput
                label={t('planInfo.fields.plannavn')}
                placeholder={t('planInfo.fields.plannavnPlaceholder')}
                value={values.plannavn}
                    error={errors.plannavn}
                onChange={e => onChange('plannavn', e.target.value)}
            />
            <div className={layout.twoColumn}>
                <Select
                    label={t('planInfo.fields.plantype')}
                    placeholder={t('planInfo.fields.plantypePlaceholder')}
                    value={values.plantype}
                    error={errors.plantype}
                    onChange={e => onChange('plantype', e.target.value)}
                    options={plantypeOptions}
                />
                <Select
                    label={t('planInfo.fields.planstatus')}
                    placeholder={t('planInfo.fields.planstatusPlaceholder')}
                    value={values.planstatus}
                    error={errors.planstatus}
                    onChange={e => onChange('planstatus', e.target.value)}
                    options={planstatusOptions}
                />
            </div>
            <Switch
                label={t('newPlan.fields.planbestemmelser')}
                labelPosition="right"
                className={layout.switch}
                checked={values.planbestemmelser}
                onChange={v => onChange('planbestemmelser', v)}
            />
        </PageSection>
    );
};

export default NameStatusSection;
